import { SiriusTabs as Tabs, SiriusTabsProps as TabsProps, TabPaneProps } from './Tabs';
export { Tabs };
export default Tabs;
